import {IWithSummaryModel} from "../../../../../common/permission/api/entity/iWithSummary.model";
import {InsoleElementDefinitionSummaryModel} from "./insoleElementDefinitionSummary.model";
import {LovValueSummary} from "../../../../../common/lov/lov-value/api/model/lovValueSummary.model";

export class InsoleElementDefinitionModel implements IWithSummaryModel<InsoleElementDefinitionSummaryModel>{
    summary: InsoleElementDefinitionSummaryModel;
    hasHeight: boolean;
    hasThickness: boolean;
    hasHardness: boolean;
    hasMultipleHardnesses: boolean;
    position: LovValueSummary;
    category: LovValueSummary;
}